module.exports = __webpack_public_path__ + "static/media/covid1.435f0d67.mp4";